import api from '@mint-lib/api';
import { useQuery } from '@mint-lib/query-client';

import { MEDIA_PLAN_VERSIONS } from '../constants/EndpointConstants.js';
import { QueryKey } from '../constants/queryKeys.js';
import { ChannelMixVersionResponseSchema } from '../types/buyingPlanVersions.js';

const getChannelMix = async (versionId: number) => {
  const response = await api.get(
    `${MEDIA_PLAN_VERSIONS}${versionId}/channel_mix/`,
  );
  return ChannelMixVersionResponseSchema.parse(response.data);
};

const KEEP_STALE_FOR_MS = 60 * 1000;

export const useGetVersionChannelMixData = (options: {
  versionId: number | null;
  skip?: boolean;
}) => {
  const { versionId, skip } = options;
  return useQuery({
    queryKey: [QueryKey.CHANNEL_MIX_VERSION, { versionId }],
    queryFn: () => getChannelMix(versionId ?? 0),
    enabled: !!versionId && !skip,
    staleTime: KEEP_STALE_FOR_MS,
  });
};
